import { normalizeControlValue } from '@/components/DeviceProperty/model'

const object = value => value && typeof value === 'object' && !Array.isArray(value)
const identifier = value => typeof value === 'string' && /^[A-Za-z0-9_-]{1,64}$/.test(value)
const scalar = value => typeof value === 'string' || typeof value === 'boolean' || (typeof value === 'number' && Number.isFinite(value))
const forbidden = new Set(['__proto__', 'constructor', 'prototype'])

// 旧节点没有运行输入标记时仍是固定目标，不能因客户端升级扩大已发布能力。
export const groupRuntimeValue = option => !!option && option.valueSource === 'runtime'

// 画布只保留绑定；运行输入仅留在组件内存，不保存设备名单、权限或运行目标。
export function groupControlBinding (option) {
  if (!object(option) || !identifier(option.groupId) || !identifier(option.productId)) throw new Error('请选择有效的设备群组')
  if (typeof option.propertyId !== 'string' || !/^[\p{L}\p{N}_.:-]{1,128}$/u.test(option.propertyId) || forbidden.has(option.propertyId)) throw new Error('请选择有效的群控属性')
  if (option.valueSource !== undefined && !['fixed', 'runtime'].includes(option.valueSource)) throw new Error('群控目标来源无效')
  if (!groupRuntimeValue(option) && (!scalar(option.targetValue) || (typeof option.targetValue === 'string' && option.targetValue.length > 4096))) throw new Error('旧版群控缺少有效的固定目标值，请在编辑器重新配置并保存')
  return { groupId: option.groupId, productId: option.productId, propertyId: option.propertyId,
    ...(groupRuntimeValue(option) ? { valueSource: 'runtime', targetValue: null } : { targetValue: option.targetValue }) }
}

export function groupBooleanTarget (property, value) {
  if (!property || property.type !== 'boolean') return null
  if (Object.is(value, property.trueValue === undefined ? true : property.trueValue)) return true
  if (Object.is(value, property.falseValue === undefined ? false : property.falseValue)) return false
  return null
}

export function groupControlValue (property, input) {
  const value = normalizeControlValue(property, input)
  if (!scalar(value) || (typeof value === 'string' && value.length > 4096)) throw new Error('群控目标值超出支持范围')
  return value
}

// 服务端/旧固定目标已经是原始别名，不能再次把 Boolean 当作UI开关方向映射。
export function groupControlRawValue (property, value) {
  if (!property || property.type !== 'boolean') return groupControlValue(property, value)
  const on = groupControlValue(property, true), off = groupControlValue(property, false)
  if (!Object.is(value, on) && !Object.is(value, off)) throw new Error('目标不在物模型声明的开关值中')
  return value
}

// 预检过程中若类型、别名、约束或候选含义改变，必须让用户按新控件重新确认输入。
export function groupControlSchemaKey (property) {
  if (!property) return ''
  return JSON.stringify(['id', 'name', 'type', 'unit', 'min', 'max', 'scale', 'maxLength', 'trueText', 'falseText'].map(key => [key, property[key]])
    .concat([['trueValue', property.trueValue === undefined ? true : property.trueValue], ['falseValue', property.falseValue === undefined ? false : property.falseValue],
      ['elements', Array.isArray(property.elements) ? property.elements.map(item => [item.value, item.text]) : null]]))
}

export function groupTargetText (value) {
  return scalar(value) ? typeof value === 'string' && value === '' ? '空字符串' : String(value) : '未设置'
}

export function groupPropertyLabel (property, value) {
  if (!property) return groupTargetText(value)
  if (property.type === 'boolean') {
    if (Object.is(value, property.trueValue === undefined ? true : property.trueValue)) return property.trueText || '开启'
    if (Object.is(value, property.falseValue === undefined ? false : property.falseValue)) return property.falseText || '关闭'
  }
  if (property.type === 'enum' && Array.isArray(property.elements)) {
    const entry = property.elements.find(item => Object.is(item.value, value))
    if (entry) return entry.text || groupTargetText(value)
  }
  return groupTargetText(value) + (property.unit ? ' ' + property.unit : '')
}

export function groupDeviceResultText (state) {
  return { pending: '等待执行', sending: '发送中', succeeded: '已确认成功', failed: '失败', unknown: '结果未知', skipped: '已跳过' }[state] || '结果待核实'
}
